<template>
  <div class="options">
<!--    <item @click.native="route('/customer/tagging/key_work')" path="/customer/tagging/key_work">-->
<!--      关键词打标签-->
<!--    </item>-->
    <item @click.native="route('/customer/tagging/add_group')" path="/customer/tagging/add_group">
      客户入群行为打标签
    </item>
    <item @click.native="route('/customer/tagging/day_part')" path="/customer/tagging/day_part">
      分时段打标签
    </item>

  </div>
</template>

<script>
import Item from "views/customer/childComps/tagging/Item";
export default {
  name: "Options",
  components: {
    Item
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    click() {
      this.$emit('update:show', true)
    },
    route(path) {
      if (path === this.$route.path) {
        this.$router.push({
          path: '/route',
          query: {path}
        })
      }
    },
  }
}
</script>

<style scoped>
.options {
  width: 100%;
  height: 50px;
  background-color: #FFFFFF;
}
.manage_title {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 15px;
  margin-right: 10px;
  cursor: pointer;
}
.right {
  float: right;
  margin-top: 10px;
  margin-right: 15px;
}
.right> .el-button {
  border-radius: 2px;
  width: 80px;
  height: 32px;
  background-color: var(--themeColors);
  padding: 0;
  color: #FFFFFF;
  border: none;
}
.right> .el-button:hover {
  background-color: var(--themeColorsHover);
}
</style>